import { Link } from 'react-router-dom';

const TypingDots = () => (
  <div className="flex items-center gap-1 px-4 py-3">
    {[0, 1, 2].map(i => (
      <span key={i} className="w-1.5 h-1.5 rounded-full bg-[#F29B3D]/70 animate-bounce" style={{ animationDelay: `${i * 0.15}s` }} />
    ))}
  </div>
);

const BotAvatar = () => (
  <img src="/kasara-avatar.jpg" alt="Kasara" className="w-7 h-7 rounded-full object-cover border border-[#F29B3D]/30 shrink-0 mt-1" />
);

const PATH_RE = /(\/(?:docs|services|pricing|solutions|migrate|contact|developers|security|resources|about|why-daakyi|careers|status|support)(?:\/[a-z0-9-]+)*\/?)/g;

const linkify = (text) => {
  const parts = text.split(PATH_RE);
  return parts.map((part, i) => {
    if (i % 2 === 1) {
      return (
        <Link key={`lnk-${i}`} to={part} className="text-[#A8631A] underline underline-offset-2 hover:text-[#DD8226] font-medium">
          {part}
        </Link>
      );
    }
    return part;
  });
};

const MessageBody = ({ msg, isTyping }) => {
  if (msg.text) {
    if (msg.role === 'bot') return <>{linkify(msg.text)}</>;
    return msg.text;
  }
  if (msg.role === 'bot' && isTyping) return <TypingDots />;
  return null;
};

export const KasaraMessages = ({ messages, isTyping }) => (
  <>
    {messages.map((msg, idx) => (
      <div key={`msg-${msg.role}-${idx}`} className={`flex gap-2 ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}>
        {msg.role === 'bot' && <BotAvatar />}
        <div
          data-testid={`chat-message-${idx}`}
          className={`max-w-[82%] px-4 py-2.5 rounded-2xl text-sm leading-relaxed whitespace-pre-wrap ${
            msg.role === 'user'
              ? 'bg-gradient-to-r from-[#F29B3D]/20 to-[#DD8226]/15 text-[#1A1240] border border-[#E2E8F0] rounded-br-md'
              : 'bg-[#FFFFFF]/80 text-[#374151] border border-[#E2E8F0] rounded-bl-md'
          }`}
        >
          <MessageBody msg={msg} isTyping={isTyping} />
        </div>
      </div>
    ))}
  </>
);
